import { load, save } from '../lib/storage';
export const TUTORIAL_DONE = 'ancientnine.tutorialDone';
export const tutorialDone = (): boolean => load(TUTORIAL_DONE, false);
export const markTutorialDone = (): void => save(TUTORIAL_DONE, true);
/** sessionStorage flag set by the finish's Play button: home opens the Play sheet on mount. */
export const OPEN_PLAY = 'ancientnine.openPlay';
